import React , {useEffect,useState} from "react";
import InstractorAwardsControl from './InstractorAwardsControl'
import { useParams } from 'react-router-dom';
import { getIdData } from "../../../lib/studentinfo";
import Student12TopMenu from "../studentInfo/student12topmenu"
import Student911TopMenu from "../studentInfo/student911topmenu"

const InstructorStudentGoalTracker = () => {
  let { slug } = useParams();
  const [isStudent911, setisStudent911] = useState(false);
  const [isStudent12, setisStudent12] = useState(false);

  async function GetData() {
    const info = await getIdData(slug);
    if (info[0].role === "Student911") {
      setisStudent911(true);
    } else if (info[0].role === "Student12") {
      setisStudent12(true);
    }
  }
   
    useEffect(() => {
      GetData();
    }, []);

  return (
    <>
       {isStudent911 && <Student911TopMenu slug={slug} activeMenu={"Awards"} /> }
       {isStudent12 && <Student12TopMenu slug={slug} activeMenu={"Awards"} /> }     
      <InstractorAwardsControl />
    </>
  )
}

export default InstructorStudentGoalTracker